import React, { useContext, useLayoutEffect, useState } from "react";

import { Environment, environment } from "../config";

export enum ConfigNames {
  isDrawingsLayout = "isDrawingsLayout",
}

type LocalConfig = Record<ConfigNames, boolean>;
const LOCAL_CONFIG: LocalConfig = Object.freeze({
  isDrawingsLayout: false,
});

export const ConfigContext = React.createContext<{
  localConfig: LocalConfig;
}>({ localConfig: LOCAL_CONFIG });

interface ConfigProviderProps {
  children?: React.ReactNode;
}

export const useConfig = (configName: ConfigNames) => {
  const config = useContext(ConfigContext);
  return config.localConfig[configName];
};

const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  const [localConfig, setLocalConfig] = useState<LocalConfig>(LOCAL_CONFIG);
  useLayoutEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (environment !== Environment.PROD) {
      const configOverrides = Object.keys(ConfigNames).reduce((acc, curr) => {
        return {
          ...acc,
          ...(searchParams.has(curr) && { [curr]: searchParams.get(curr) !== "false" }),
        };
      }, {});
      setLocalConfig((config) => ({ ...config, ...configOverrides }));
    }
  }, []);

  return (
    <ConfigContext.Provider value={{ localConfig: localConfig }}>{children}</ConfigContext.Provider>
  );
};

export default ConfigProvider;
